import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function FloatingDiamond({ onGoHome, onRecharge }) {
    // State quản lý việc mở/đóng menu lơ lửng
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    // Hàm xử lý khi bấm nút
    const handleAction = (type) => {
        if (type === "home") {
            if (onGoHome) onGoHome(); 
            else window.location.href = "/"; 
        } else if (type === "recharge") {
            if (onRecharge) onRecharge();
            else window.location.href = "/recharge/auto";
        }
    };

    return (
        <>
            <style>{`
                /* ========================================= */
                /* CSS NÚT LƠ LỬNG CHUẨN THIẾT KẾ ẢNH        */
                /* ========================================= */
                .floating-pill-container {
                    position: fixed;
                    right: 0;
                    top: 35%;
                    z-index: 99999;
                    display: flex;
                    align-items: center;
                    background: #444444e8;
                    border: 1px solid #333;
                    border-right: none;
                    box-shadow: -2px 2px 10px rgba(0, 0, 0, 0.4);
                    
                    /* Thay đổi hình dáng mượt mà khi click */
                    transition: all 0.3s ease;
                    
                    /* Khi đóng (false): Bo góc hẹp, đuôi dài (Ảnh 1) */
                    /* Khi mở (true): Bo góc tròn to, căn giữa đều trên dưới (Ảnh 2) */
                    border-radius: ${isOpen ? "26px 0 0 26px" : "12px 0 0 12px"};
                    padding: ${isOpen ? "10px 4px 10px 14px" : "12px 4px 30px 12px"};
                }

                /* Nút Toggle (Kim cương xanh) */
                .diamond-toggle-btn {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    z-index: 2;
                    
                    /* SỬA LỖI Ở ĐÂY: Khi đóng, đẩy kim cương xuống 9px để bù cho cái đuôi 30px */
                    transform: translateY(${isOpen ? "0px" : "9px"});
                    transition: transform 0.3s ease;
                }

                .diamond-toggle-btn img {
                    /* Nút kim cương giữ form nhỏ */
                    width: 14px; 
                    height: 14px;
                    object-fit: contain;
                    
                    /* Trạng thái đóng: hướng xuống | Trạng thái mở: xoay ngang chỉ trái */
                    transform: ${isOpen ? "rotate(-90deg)" : "rotate(0deg)"};
                    transition: transform 0.3s ease;
                }

                /* Khối chứa 2 nút Home và Nạp tiền */
                .menu-icons-wrapper {
                    display: flex;
                    align-items: center;
                    overflow: hidden;
                    transition: max-width 0.3s ease-in-out, opacity 0.3s ease-in-out, margin-left 0.3s;
                    
                    /* Ẩn hiện mượt mà */
                    max-width: ${isOpen ? "100px" : "0px"};
                    opacity: ${isOpen ? 1 : 0};
                    margin-left: ${isOpen ? "12px" : "0px"};
                    gap: 12px; 
                }

                /* Style cho từng icon thao tác */
                .action-icon {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    transition: transform 0.2s;
                }

                .action-icon:active {
                    transform: scale(0.85);
                }

                .action-icon img {
                    width: 26px; 
                    height: 26px;
                    object-fit: contain;
                }
            `}</style>

            <div className="floating-pill-container">
                
                {/* Nút Toggle (Icon kim cương) */}
                <div className="diamond-toggle-btn" onClick={toggleMenu}>
                    <img 
                        src="https://8jvf.katawee.net/system-requirement/Web.MobileNew/UK251-01/c61b0707c0/icon.808d6e242325e359.png" 
                        alt="Toggle" 
                    />
                </div>

                {/* Các nút bị ẩn/hiện */}
                <div className="menu-icons-wrapper">
                    {/* Nút Về Home */}
                    <div className="action-icon" title="Trang chủ" onClick={() => handleAction("home")}>
                        <img 
                            src="https://dgdga3.swuacktu.net/system-requirement/Web.MobileNew/UK251-01/c61b0707c0/assets/images/float-navigation/home.png" 
                            alt="Home" 
                        />
                    </div>

                    {/* Nút Nạp Tiền Nhanh */}
                    <div className="action-icon" title="Nạp tiền nhanh" onClick={() => handleAction("recharge")}>
                        <img 
                            src="https://dgdga3.swuacktu.net/system-requirement/Web.MobileNew/UK251-01/c61b0707c0/assets/images/float-navigation/deposit.gif" 
                            alt="Nạp tiền" 
                        />
                    </div>
                </div>

            </div>
        </>
    );
}

export default FloatingDiamond;